import ProductComponentBase from '@/common/ProductComponentBase';
import { PriceDto, ProductBasePrice, ProductDto, ProductNetFillQuantity } from '@eurogast/hub-client-typescript';
import { UnitDefinition } from '@/services/ProductDeserializer';
import { LinkUtil } from '@/services/LinkUtil';

export default abstract class ProductDtoComponentBase extends ProductComponentBase {
  abstract get product(): ProductDto;

  get bulkPrices(): PriceDto[] {
    return this.product.bulkPrices;
  }

  get units(): UnitDefinition[] {
    return this.product.units;
  }

  get basePrice(): ProductBasePrice {
    return this.product.basePrice;
  }

  get netFillQuantity(): ProductNetFillQuantity {
    return this.product.netFillingQuantity;
  }

  get sku(): string {
    return this.product.sku;
  }

  get detailUrl(): string {
    return LinkUtil.getProductDetailUrl(this.product.name, this.product.sku);
  }

  get productImagePath() {
    return LinkUtil.getProductImageUrl(this.product);
  }
}
